import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import SpeakersFeature from '../../features/SpeakersFeature'
import { IconComponent, LoaderWrapperComponent, RichTextComponent } from '..'
import { ReadMore } from '../../../RoomUI/components/ReadMore/ReadMore'
import { useWebinarColors } from '../../hooks/useWebinarColors'
import { useLiveDataQuery } from '../../../global/blocs/useLiveData'

import './WebinarInfoPanelComponent.scss'

const WebinarInfoPanelComponent = ({
  onSpeakersInit,
  speakersSize,
  theme = 'no',
  isShowingSpeakers,
}) => {
  const { data: liveData, isLoading } = useLiveDataQuery()

  const webinarColors = useWebinarColors()

  return (
    <div className={`webinar-info-panel-component ${theme}-theme`}>
      <LoaderWrapperComponent loading={isLoading}>
        {liveData && (
          <>
            <h3>{liveData.name}</h3>

            <div className="webinar-date">
              {theme === 'waiting-room' && (
                <IconComponent
                  name="date"
                  color="8d8e8d"
                  className="date-icon"
                />
              )}
              {liveData.primary_timezone_live_date__date} &nbsp;
              {liveData.primary_timezone_live_date__time} <br />
            </div>

            <ReadMore lines={3}>
              <RichTextComponent text={liveData.description_html} />
            </ReadMore>

            {isShowingSpeakers && (
              <>
                <h4
                  className="section-title"
                  style={{
                    color: webinarColors.tabs.contrast.transparent('85%'),
                  }}
                >
                  <FormattedMessage defaultMessage="Speakers" />
                </h4>

                <SpeakersFeature
                  namespace="info-panel-speakers"
                  listType="compact"
                  featureProps={{
                    liveId: liveData.live_id,
                    token: liveData.token,
                    isExcludingHidden: true,
                  }}
                  styles={{
                    loaderStyles: {
                      background: 'transparent',
                      opacity: 0.05,
                    },
                    textStyles: {
                      color: webinarColors.tabs.highContrast.color,
                    },
                  }}
                  onSpeakersInit={onSpeakersInit}
                  size={speakersSize}
                  renderIfEmpty={false}
                />
              </>
            )}
          </>
        )}
      </LoaderWrapperComponent>
    </div>
  )
}

WebinarInfoPanelComponent.propTypes = {
  onSpeakersInit: PropTypes.func,
  theme: PropTypes.oneOf(['waiting-room']),
  speakersSize: PropTypes.oneOf(['large', 'small']),
  isShowingSpeakers: PropTypes.bool,
}

WebinarInfoPanelComponent.defaultProps = {
  speakersSize: 'small',
}

// eslint-disable-next-line import-x/no-default-export
export default WebinarInfoPanelComponent
